export default __webpack_public_path__ + "255962309ea64c3f7ea5ac0bf0850112.png";